<div id="action-required" class="container">

  <div *ngFor="let item of data">
    <div>
      <div>
        <div class="actionRequiredHeader">
          <div class="actionRequiredPropertyHeader" title="{{item.propertyName}}"> {{ item.propertyName }}</div>
          <div>
            <button class="button_upload_file" fmButton type="button" [primary]="true" icon="fmi fmi-upload"
                    label="Upload Files"
                    (click)="showUploadFilesDialog(true, item.propertyName, item.dusGatewayDealAndID, item.collateralReferenceNumber, item.acquisitionDealId, item.propertyMasterNumber, item.transType, item.ssn, item.propId, item.cmmtNo)">
            </button>
          </div>
        </div>
        <fm-dataList>

          <ng-template fmTemplate="subheader">

            <!--insr	INS-->
            <button class="button_no" *ngIf="!item.insr || item.insr == 'N'">Missing INS</button>
            <button class="button_yes" *ngIf="item.insr == 'Y'">INS</button>
            <button class="button_no_applicable" *ngIf="item.insr == 'N/A'">INS</button>

            <!-- Add 10 buttons for additional INSR-->

            <!--propAccord25Typ	A25-->
            <button class="button_no" *ngIf="!item.propAccord25Typ || item.propAccord25Typ == 'N'">Missing A25</button>
            <button class="button_yes" *ngIf="item.propAccord25Typ == 'Y'">A25</button>
            <button class="button_no_applicable" *ngIf="item.propAccord25Typ == 'N/A'">A25</button>

            <!--propAccord28Typ	A28-->
            <button class="button_no" *ngIf="!item.propAccord28Typ || item.propAccord28Typ == 'N'">Missing A28</button>
            <button class="button_yes" *ngIf="item.propAccord28Typ == 'Y'">A28</button>
            <button class="button_no_applicable" *ngIf="item.propAccord28Typ == 'N/A'">A28</button>

            <!--propAmrcnLandTtlAsscTyp	ALTA-->
            <button class="button_no" *ngIf="!item.propAmrcnLandTtlAsscTyp || item.propAmrcnLandTtlAsscTyp == 'N'">Missing ALTA</button>
            <button class="button_yes" *ngIf="item.propAmrcnLandTtlAsscTyp == 'Y'">ALTA</button>
            <button class="button_no_applicable" *ngIf="item.propAmrcnLandTtlAsscTyp == 'N/A'">ALTA</button>

            <!--propFldAnlysWkshTyp	FAW-->
            <button class="button_no" *ngIf="!item.propFldAnlysWkshTyp || item.propFldAnlysWkshTyp == 'N'">Missing FAW</button>
            <button class="button_yes" *ngIf="item.propFldAnlysWkshTyp == 'Y'">FAW</button>
            <button class="button_no_applicable" *ngIf="item.propFldAnlysWkshTyp == 'N/A'">FAW</button>

            <!--propLiabPlcyTyp	LIA-->
            <button class="button_no" *ngIf="!item.propLiabPlcyTyp || item.propLiabPlcyTyp == 'N'">Missing LIA</button>
            <button class="button_yes" *ngIf="item.propLiabPlcyTyp == 'Y'">LIA</button>
            <button class="button_no_applicable" *ngIf="item.propLiabPlcyTyp == 'N/A'">LIA</button>

            <!--propNfipTyp	NFIP-->
            <button class="button_no" *ngIf="!item.propNfipTyp || item.propNfipTyp == 'N'">Missing NFIP</button>
            <button class="button_yes" *ngIf="item.propNfipTyp == 'Y'">NFIP</button>
            <button class="button_no_applicable" *ngIf="item.propNfipTyp == 'N/A'">NFIP</button>

            <!--propPrvtOrExcsFldInsrCvrgTyp	PFX-->
            <button class="button_no" *ngIf="!item.propPrvtOrExcsFldInsrCvrgTyp || item.propPrvtOrExcsFldInsrCvrgTyp == 'N'">Missing PFX</button>
            <button class="button_yes" *ngIf="item.propPrvtOrExcsFldInsrCvrgTyp == 'Y'">PFX</button>
            <button class="button_no_applicable" *ngIf="item.propPrvtOrExcsFldInsrCvrgTyp == 'N/A'">PFX</button>

            <!--propInsrTyp	PROP-->
            <button class="button_no" *ngIf="!item.propInsrTyp || item.propInsrTyp == 'N'">Missing PROP</button>
            <button class="button_yes" *ngIf="item.propInsrTyp == 'Y'">PROP</button>
            <button class="button_no_applicable" *ngIf="item.propInsrTyp == 'N/A'">PROP</button>

            <!--propSpclFldHzrdDtmnFormTyp	SFHDF-->
            <button class="button_no" *ngIf="!item.propSpclFldHzrdDtmnFormTyp || item.propSpclFldHzrdDtmnFormTyp == 'N'">Missing SFHDF</button>
            <button class="button_yes" *ngIf="item.propSpclFldHzrdDtmnFormTyp == 'Y'">SFHDF</button>
            <button class="button_no_applicable" *ngIf="item.propSpclFldHzrdDtmnFormTyp == 'N/A'">SFHDF</button>

            <!--propSchOfValTyp	SOV-->
            <button class="button_no" *ngIf="!item.propSchOfValTyp || item.propSchOfValTyp == 'N'">Missing SOV</button>
            <button class="button_yes" *ngIf="item.propSchOfValTyp == 'Y'">SOV</button>
            <button class="button_no_applicable" *ngIf="item.propSchOfValTyp == 'N/A'">SOV</button>

            <!-- Display the required submitted date based on the date -->
            <div class="my_datalist_container">
              <div class="my_datalist_label">REQUIRED SUBMISSION DATE</div>
              <div class="my_datalist_text" *ngIf="item.pastDue == true">{{ item.requiredSubmittedDate }}
              </div>
              <div class="my_datalist_text_highlight" *ngIf="item.pastDue == false">
                {{ item.requiredSubmittedDate }}
              </div>
            </div>

            <div class="my_datalist_container">
              <div class="my_datalist_label">LAST SUBMITTED DATE</div>
              <div class="my_datalist_text">{{ item.lastSubmittedDate }}</div>
            </div>

            <div class="my_datalist_container">
              <div class="my_datalist_label">DUS GATEWAY DEAL AND ID</div>
              <div class="my_datalist_text">{{ item.dusGatewayDealAndID }}</div>
            </div>

            <div class="my_datalist_container">
              <div class="my_datalist_label">(EST.) ACQUISITION DATE</div>
              <div class="my_datalist_text">{{ item.estimatedAcquisitionDate }}</div>
            </div>

            <div class="my_datalist_container_no_line">
              <div class="my_datalist_label">COLLATERAL REFERENCE NUMBER</div>
              <div class="my_datalist_text">{{ item.collateralReferenceNumber }}</div>
            </div>
          </ng-template>

          <ng-template fmTemplate="rowText" let-rowItem>
            <div style="color: black; float: right;">{{ rowItem.text }}</div>
          </ng-template>

        </fm-dataList>
      </div>
    </div>
  </div>
</div>
<app-file-upload-insurance *ngIf="showUploadFiles"
                           (showUploadFiles)="getUploadFilesDialogStatus($event)"></app-file-upload-insurance>
